import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    day: 'Día 1',
    title: 'Prepara el entorno',
    desc: 'Ajustas el cuarto con nuestra lista de control.'
  }, {
    day: 'Día 3',
    title: 'Sincroniza',
    desc: 'Alineas las siestas con el horario laboral/Daycare.'
  }, {
    day: 'Día 7',
    title: 'Entrena',
    desc: 'Aplicas el protocolo de 15 minutos y disfrutas de tu primera noche de 6 horas.'
  }];
  return <section className="py-24 px-4 bg-navy-800" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <FadeIn data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-16 text-center" data-id="element-120">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-121">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-[2px] bg-navy-600 z-0" data-id="element-122" />

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 left-8 w-[2px] h-full bg-navy-600 z-0" data-id="element-123" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-124">
            {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="flex md:flex-col items-start md:items-center gap-6 md:gap-8" data-id="element-125">
                <div className="w-16 h-16 shrink-0 rounded-full bg-navy-900 border-2 border-gold flex items-center justify-center text-2xl font-bold text-gold shadow-[0_0_15px_rgba(212,168,83,0.2)]" data-id="element-126">
                  {index + 1}
                </div>
                <div className="md:text-center pt-2 md:pt-0" data-id="element-127">
                  <span className="text-gold text-sm font-bold tracking-wider uppercase mb-2 block" data-id="element-128">
                    {step.day}
                  </span>
                  <h3 className="text-xl font-bold text-cream mb-3 font-serif" data-id="element-129">
                    {step.title}
                  </h3>
                  <p className="text-muted leading-relaxed" data-id="element-130">{step.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}